import { Card, Table } from "react-bootstrap";

function cmToFeetInches(cm) {
    const inchesTotal = cm / 2.54;
    const feet = Math.floor(inchesTotal / 12);
    const inches = (inchesTotal % 12).toFixed(0);

    return `${feet} FT. ${inches} In.`;
}

const ReferalObjects = ({ data, listingObjects }) => {
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    // Get IDs of existing listingObjects (fallback to [] if undefined)
    const existingIds = (listingObjects || []).map(item => item.referral_object);

    // Filter out items from data that already exist in listingObjects
    const filteredData = data.filter(item => !existingIds.includes(item.id));

    if (filteredData.length === 0) {
        return <div>No new referral objects to display.</div>;
    }

    return (
        <Card>
            <Card.Body>
                <h6>Referral Objects</h6>
                <div className="mt-4">
                    {filteredData.map((object, index) => (
                        <Card key={object?.id}>
                            <Card.Header>{object?.type}</Card.Header>
                            <Card.Body>
                                {object?.type === "ReferralBoat" ? (
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Boat name</th>
                                                <th>Length</th>
                                                <th>Width</th>
                                                <th>Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{object?.boat_name ?? "N/A"}</td>
                                                <td>
                                                    {object?.referral_type === "seller"
                                                        ? cmToFeetInches(object?.length) ?? "N/A"
                                                        : `${object?.min_length ?? "N/A"} - ${object?.max_length ?? "N/A"}`}
                                                </td>
                                                <td>
                                                    {object?.referral_type === "seller"
                                                        ? cmToFeetInches(object?.width) ?? "N/A"
                                                        : `${object?.min_width ?? "N/A"} - ${object?.max_width ?? "N/A"}`}
                                                </td>
                                                <td>
                                                    {object?.referral_type === "seller"
                                                        ? object?.price ?? "N/A"
                                                        : `${object?.min_price ?? "N/A"} - ${object?.max_price ?? "N/A"}`}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                ) : <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Boat name</th>
                                            <th>General Species</th>
                                            <th>Area</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{object?.boat_name ?? "N/A"}</td>
                                            <td>
                                                {object?.species_name ?? "N/A"}
                                            </td>
                                            <td>
                                                {object?.area_name ?? "N/A"}
                                            </td>
                                            <td>
                                                {object?.referral_type === "seller"
                                                    ? object?.price ?? "N/A"
                                                    : `${object?.min_price ?? "N/A"} - ${object?.max_price ?? "N/A"}`}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>}
                            </Card.Body>
                        </Card>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default ReferalObjects;
